export const LIST = [
  {
    image:'card-applepay',
    name:'applepay'
  },
  {
    image:'card-googlepay',
    name:'googlepay'
  },
  {
    image:'card-monobank',
    name:'monobank'
  },
  {
    image:'card-privat24',
    name:'privat24'
  },
  {
    image:'card-paypal',
    name:'paypal'
  },
  {
    image:'card-visa',
    name:'visa'
  },
  {
    image:'card-mastercard',
    name:'master'
  },
]
